import React , {Component} from 'react';
import { Row } from 'antd';
import "../../asset/style/morpheus.css"
import "../../asset/style/landing.css"

export class Hero extends Component {

    render(){
        return(
            <Row className="hero-parent full-widther">
                Hero
            </Row>
        )
    }
  }